<template>
  <MainLayout>
    <ReservationList />
  </MainLayout>
</template>

<script>
// @ is an alias to /src
import MainLayout from '@/layouts/MainLayout.vue';
import ReservationList from '@/components/reserve/ReservationList.vue';

export default {
  name: 'ReservationListView',
  components: {
    MainLayout,
    ReservationList,
  },
  beforeRouteEnter(to, from, next) {
    const fromPath = from?.path;

    if (!fromPath.includes('/reservations/')) {
      sessionStorage.removeItem('reCondition');
    }
    next();
  },
};
</script>
